<template>
     <div>
         <div class="title-div">
             <p>Verify Email</p>
         </div>
         <div class="sub-div">
             <p>
                 Enter the verification code sent to the below email to add it to your Identity Vault. We'll start scanning for
                 exposures linked to it.
                 <span class="block mt-1">
                     Email: <span class="font-bold break-all">{{ dialogRef.data.email }}</span>
                 </span>
             </p>
         </div>
     </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

//dialog ref
const dialogRef = getDialogRef(ModalNames.EMAIL_VERIFICATION);
</script>
<style lang="scss" scoped>
.title-div {
    @apply flex flex-row justify-between w-full;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.sub-div {
    @apply self-stretch;

    p {
        @apply text-gray-600 text-sm font-normal leading-5 font-inter;
    }
}
</style>